import { FC, useCallback, useState } from 'react';

import { dispatch } from 'store';
import { resetStore, setCurrentCountry } from 'modules/app/actions';
import logo from 'assets/images/logo.svg';
import styles from './HeaderSecond.module.css';
import { LanguagesSelect } from 'views/components';

export const HeaderSecond: FC = () => {
  const logout = useCallback(() => {
    const isLogout = confirm('Are you sure to logout');
    if (isLogout) {
      dispatch(resetStore());
      const county = localStorage.getItem('country') || 'US';
      dispatch(setCurrentCountry(county))
    }
  }, [dispatch]);

  return (
    <div className={styles.wrap}>
      <a href="/dashboard" style={{ display: 'inline-block', marginBottom: 20 }}>
        <img src={logo} alt="logo" />
      </a>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          flexDirection: 'column',
        }}
      >
        <LanguagesSelect />
        <a className={styles.link} href="#" onClick={() => logout()}>
          Logout
        </a>
      </div>
    </div>
  );
};
